import React from 'react';
import { Button, IconArrow } from 'gatorcomponents';
import { useIsMobile } from '@/hooks/useIsMobile';
import upgradeVps from './assets/upgrade-vps.png';
import upgradeVpsMobile from './assets/upgrade-vps-mobile.png';
import * as Styles from './VpsCustomizer.styles';

const VpsCustomizer = ({
  locales,
  onGoToTemplatesPage,
}) => {
  const isMobile = useIsMobile();

  const handleGoToTemplatesPage = () => {
    onGoToTemplatesPage && onGoToTemplatesPage();
  };

  return (
    <Styles.Card>
      <Styles.BlockText>
        <Styles.Title>{locales.title}</Styles.Title>
        <Styles.Description>{locales.description}</Styles.Description>

        <Styles.Actions>
          <Button
            onClick={handleGoToTemplatesPage}
            testId="vpsoci-change-plan-card-button"
            label={locales.buttonLabel}
            variant="secondary"
            inverse
            size="large"
            version="v2"
            width={isMobile ? 'full' : 'fit-content'}
            iconRight={<IconArrow direction="right" />}
          />
        </Styles.Actions>
      </Styles.BlockText>
      <Styles.BlockImage>
        <Styles.Image
          src={isMobile ? upgradeVpsMobile : upgradeVps}
          alt={locales.title}
        />
      </Styles.BlockImage>
    </Styles.Card>
  );
};

export default VpsCustomizer;
